import { ReactNode } from 'react';

import { Unarray } from '@pukka/common/types';
import { Root, TabsList, TabsContent, TabsProps } from '@radix-ui/react-tabs';

import { CommonTabProps } from '../../types';

import { Trigger } from './Trigger';

interface BillingProps extends Omit<TabsProps, 'onChange' | 'onValueChange' | 'content'>, Omit<CommonTabProps, 'data'> {
  readonly data: (Unarray<CommonTabProps['data']> & {
    readonly subtitle?: string;
    readonly children?: ReactNode | (() => ReactNode);
  })[];
}

function Billing({ index, value, data, content, onChange, disabled, ...props }: BillingProps) {
  const currentValue = value ?? (index !== undefined ? data[index]?.key ?? data[index]?.value : undefined);

  return (
    <Root value={currentValue} onValueChange={onChange} {...props}>
      <TabsList className="grid auto-cols-fr grid-flow-col gap-3">
        {data.map((d) => {
          const _disabled = disabled || (typeof d.disabled === 'function' ? d.disabled(currentValue) : d.disabled);

          return (
            <Trigger key={d.key ?? d.value} value={d.key ?? d.value} title={d.title || d.value} subtitle={d.subtitle} disabled={_disabled}>
              {typeof d.children === 'function' ? d.children() : d.children}
            </Trigger>
          );
        })}
      </TabsList>
      {data.map((d) => (
        <TabsContent role="tabpanel" key={d.key ?? d.value} value={d.key ?? d.value}>
          {d.content ?? content}
        </TabsContent>
      ))}
    </Root>
  );
}

Billing.Root = Root;
Billing.List = TabsList;
Billing.Trigger = Trigger;
Billing.Content = TabsContent;

export { Billing };
